import defaultState from '../defaultState';
const defaultUsers = defaultState.users;

export default function users(state = defaultUsers, action) {
  switch (action.type) {
    case 'UPDATE_USERS':
      return action.users;

    case 'LOGOUT':
      return [];

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/users.js